import React from 'react'

export default function Accounts() {
  return <div>Accounts</div>
}
